module.exports = __webpack_public_path__ + "img/gris_moyen_1897.220d31ee.jpg";